/* Coming-soon password entry: toggles the inline storefront-password fields. */
(function () {
  var toggle = document.querySelector('[data-aa-pw-toggle]');
  if (!toggle) return;
  var fields = document.getElementById(toggle.getAttribute('aria-controls'));
  toggle.addEventListener('click', function () {
    var open = fields.hidden;
    fields.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
    if (open) fields.querySelector('input').focus();
  });
})();
